import React from 'react';
import { formatCurrency, formatDate, generatePDF } from '../../services/api';

const PrintableReceipt = ({
  id,
  shop = {
    name: 'शांति ज्वेलर्स',
    address: 'शंकर डेयरी के पास, नदी डेयरी के बगल में, सर्कुलर मार्केट, पावर हाउस, कैंप-2, भिलाई (छ.ग.)',
    phone1: '9755489059',
    phone2: '9893951110',
  },
  receipt = {
    number: '',
    date: new Date().toISOString(),
    loanNumber: '',
    paymentNumber: '',
  },
  customer = {
    name: '',
    fatherOrSpouse: '',
    address: '',
    mobile1: '',
    mobile2: '',
    aadhar: '',
    code: '',
  },
   loan = {
     amount: 0,
     interestRate: undefined,
     agreement: '',
     itemsText: '',
   },
   meta = {
     paidMonths: [],
   },
}) => {
  const elementId = id || 'printable-receipt';

  const handlePrint = async () => {
    await generatePDF(elementId, `receipt_${receipt.number || 'loan'}.pdf`);
  };

  return (
    <div className="bg-white border p-4" id={elementId}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-2xl font-bold text-red-800">{shop.name}</div>
          <div className="text-xs text-gray-700 max-w-xl">{shop.address}</div>
        </div>
        <div className="text-right text-sm text-gray-800">
          <div>मोबाः {shop.phone1}</div>
          <div>{shop.phone2}</div>
        </div>
      </div>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
        <div>{customer.code ? (<span>Customer # {customer.code}</span>) : null}</div>
        {/* <div>{customer.fatherOrSpouse ? (<span>Father/Guardian: {customer.fatherOrSpouse}</span>) : null}</div> */}
        <div className="inline-flex items-center gap-4 whitespace-nowrap">
          {receipt.loanNumber ? (<span>Loan # {receipt.loanNumber}</span>) : null}
                 </div>
        <div >          
          {receipt.paymentNumber ? (<span>Payment # {receipt.paymentNumber}</span>) : null}
        </div>
      </div>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
        <div>रुकम ————————————</div>
        <div>दिनांक — {formatDate(receipt.date)}</div>
        
      </div>

      <div className="mt-2 space-y-2 text-sm">
        <div>मैं, — {customer.name}</div>
        <div>पिता / पति का नाम — {customer.fatherOrSpouse || '—'}</div>
        <div>पता — {customer.address}</div>
        <div className="grid grid-cols-2 gap-2">
          <div>मोबाइल — {customer.mobile1}{customer.mobile2 ? `, ${customer.mobile2}` : ''}</div>
          {typeof loan.interestRate === 'number' && !Number.isNaN(loan.interestRate) ? (
            <div>ब्याज — {loan.interestRate}%</div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>आधार क्र. — {customer.aadhar}</div>
          <div>करार — {loan.agreement || '—'}</div>
        </div>
        <div>
          रकम की एवज में जेवर (सोना/चांदी) — {loan.itemsText}
        </div>
        {(meta?.paidMonths?.length || 0) > 0 && (
          <div>कवर किए गए महीने — {meta.paidMonths.join(', ')}</div>
        )}
        <div className="grid grid-cols-2 gap-2">
          <div>रकम रु — {formatCurrency(Number(loan.amount) || 0)}</div>
          <div>अक्षरी — —————————————</div>
        </div>
      </div>

      {/* Terms removed as requested */}

      <div className="mt-4 flex items-center justify-between text-sm">
        <div>गिरवी रखने वाले का हस्ताः —————————</div>
        <div>गिरवी छुड़ाने वाले का हस्ताः —————————</div>
      </div>

      <div className="mt-4">
        <button onClick={handlePrint} className="px-3 py-1 border rounded text-sm">Print Customer Copy</button>
      </div>
    </div>
  );
};

export default PrintableReceipt;


